// A simple flat object compare utility.
// Origin: https://stackoverflow.com/a/68091909/18341117
import { isEqual, map, reduce } from 'lodash-es';

export const compareFlatObject = (
  obj1: Record<string, string | number | boolean>,
  obj2: Record<string, string | number | boolean>
): boolean => {
  if (!obj1 || !obj2) {
    return false;
  }

  return (
    Object.entries(obj1).sort().toString() ===
    Object.entries(obj2).sort().toString()
  );
};

export const converObjectToArray = (value: any): string[] => {
  const values: string[] = [];

  if (value) {
    Object.keys(value).map((key) => values.push(`${key}: ${value[key]};`));
  }

  return values;
};

export const getKeysWithDifferentValues = (obj1: any, obj2: any) => {
  const result: { keys: string[] } = {
    keys: [],
  };

  reduce(
    obj1,
    (result, value, key): any => {
      if (!obj1 || !obj2) {
        return;
      }
      if (obj2[key] !== undefined) {
        if (isEqual(value, obj2[key]) || !result) {
          return result;
        }
        if (typeof obj1[key] !== typeof {} || typeof obj2[key] !== typeof {}) {
          result.keys.push(key);
          return result;
        }
        const deeper = getKeysWithDifferentValues(obj1[key], obj2[key]);
        result.keys = result.keys.concat(
          map(deeper.keys, (subPath) => {
            return `${key}.${subPath}`;
          })
        );
      }
    },
    result
  );

  return result;
};

export const hasOwnProperty = (obj: object, propName: string): boolean =>
  obj ? Object.prototype.hasOwnProperty.call(obj, propName) : false;

export function removeEmptyValuesFromObject(
  obj: Record<string, string[] | number[] | string>
) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (Array.isArray(value)) {
        // Remove empty values from arrays
        const filteredArray = value.filter((v) => v !== '');
        return [key, filteredArray];
      }
      return [key, value];
    })
  );
}

export const removeUndefinedValues = (
  obj: Record<string, any>,
  options?: { keepEmptyStrings?: boolean }
) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, val]) =>
      options?.keepEmptyStrings ? val || val === '' : val
    )
  );

export const getObjectPropertyPathsWithValues = (
  obj: Record<string, any>,
  transformFn?: (key: string) => string,
  parentKey = ''
): { path: string; value: any }[] => {
  let result: { path: string; value: any }[] = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const transformedKey = transformFn ? transformFn(key) : key;

      const currentPath = parentKey
        ? `${parentKey}.${transformedKey}`
        : transformedKey;
      if (typeof value === 'object' && value !== null) {
        result = result.concat(
          getObjectPropertyPathsWithValues(value, transformFn, currentPath)
        );
      } else {
        result.push({ path: currentPath, value });
      }
    }
  }

  return result;
};
